/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsListNewsResponse } from "./NewsListNewsResponse";

export type NewsListNewsResponseApiRespoonse = {
  data?: NewsListNewsResponse;
  status?: NewsListNewsResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace NewsListNewsResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
